import { Component, HostListener, inject, signal } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { FullLinechartFuel } from '../full-linechart-fuel/full-linechart-fuel.component';
import { ChartData, MultiLineChartComponent } from '../../../../_shared';
import { TranslocoDirective } from '@jsverse/transloco';

@Component({
  selector: 'app-fuel-cost-breakdown',
  standalone: true,
  imports: [MultiLineChartComponent, TranslocoDirective],   // , LinechartDistance, CostLinecartNew
  templateUrl: './fuel-cost-breakdown.component.html',
  styleUrl: './fuel-cost-breakdown.component.scss'
})
export class FuelCostBreakdown {
  private readonly modalRef = inject(NgbActiveModal);
  private readonly modalService = inject(NgbModal);

  protected fuelCostChartData = ChartData.fuelCost;
  protected fuelCostChartConfig = ChartData.fuelCostConfig;
  protected yConfig = { prefix: 'R ', suffix: '/ℓ', yTickFormat: ((d: any) => `${d}/ℓ`), yStartsFromZero: false }

  public fullChart = signal<boolean>(false);

  protected closeModal(): void {
    this.modalRef.close();
  }
  fullChartClick(): void {
    // this.dialog.open(FullLinechartFuel, {
    //   panelClass: ['fuelGraphModal'],
    // });

    const modalOptions: NgbModalOptions = {
      centered: true,
      backdrop: 'static',
      size: 'xl',
    };
    const modalRef = this.modalService.open(FullLinechartFuel, modalOptions);
  }
  protected buttonMenuClick(event: MouseEvent): void {
    event.stopPropagation();
  }

  protected monthToDate = signal<boolean>(false);

  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    if (!target.closest('.datelisting') && !target.closest('.customDatePicker')) {
      this.monthToDate.set(false)
    }
  }
}
